module.exports = __webpack_public_path__ + "img/rqCode.9e17535f.png";